import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "../services/translate.service";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Pipe({
    name: 'translate_menu',
    standalone: false
})
export class TranslateMenuPipe implements PipeTransform {
  constructor(private translateService: TranslateService) { }

  transform(item: any): Observable<string> {
    var item_trans = "";
    var trans_key = item.name_translation_key? item.name_translation_key: item.name;
    return this.translateService.translate(trans_key).pipe(
      map((tran_text) => {
        if (tran_text) {
          if (tran_text.includes("menu."))
            item_trans = item.name;
          else
            item_trans = tran_text;
        }
        return item_trans;
      })
    );
  }

}